<template>
  <div class="content projectAdd">
    <p class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right color3">
            <el-breadcrumb-item>项目</el-breadcrumb-item>
            <el-breadcrumb-item>项目信息编辑</el-breadcrumb-item>
        </el-breadcrumb>
    </p>
    <el-form ref="form" :model="form" label-width="0">
      <el-card class="box-card">
        <div style="display:flex;width:100%;justify-content: space-between;">
          <div style="width:30%;display:flex;align-items: center;">
            <p class="required" style="width:120px;">项目名称：</p>
            <el-input v-model="form.name" style="flex:1;"></el-input>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p style="width:120px;">项目类型：</p>
            <el-select v-model="form.projectType" class="box-select" placeholder="请选择">
              <el-option v-for="(item,index) in types" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p style="width:120px;">项目状态：</p>
            <el-select v-model="form.projectStatus" class="box-select" placeholder="请选择">
              <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <el-button type="primary" style="float: right;" @click="saveProject" icon="el-icon-edit-outline">保存</el-button>
        </div>
      </el-card>
       <!-- 参建单位 -->
       <el-card class="box-card desc-card" v-if="entList.length!=0">
        <p style="margin:0 0 5px 0;text-align: left;">参建单位：</p>
        <ul class="ul_box"  v-for="item in entList" :key="item.projectEntId">
          <li style="width:20%">{{item.label}}</li>
          <li style="width:40%">
               <div>参建单位名称：{{item.entName}}</div>
               <div>联系人：{{item.personName}}</div>
          </li>
          <li style="width:40%">
              <div>统一社会信用代码：{{item.creditCode}}</div>
              <div>联系电话：{{item.personPhone}}</div>
          </li>
        </ul>
      </el-card>
      <el-card class="box-card">
        <p style="margin:0 0 5px 0;text-align: left;">项目概况：</p>
        <el-input type="textarea" class="no-border" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请编辑项目概况" v-model="form.description"></el-input>
      </el-card>
      <el-card class="box-card">
        <div style="display:flex;width:100%;">
          <div style="width:30%;display:flex;align-items: center;">
              <p style="width:7.8vw;">实名制上传：</p>
              <el-cascader
                :props="{value:'id',label:'name'}"
                :options="areas"
                v-model="selectedOptions"
                change-on-select="true"
              ></el-cascader>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p>登录ID：</p>
            <el-input class="no-border" v-model="form.loginId" placeholder="请您编辑" style="flex:1;"></el-input>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p>投资方性质：</p>
            <el-select v-model="form.yhType" class="box-select" placeholder="请选择">
              <el-option label="政府投资" value="1"></el-option>
              <el-option label="社会投资" value="3"></el-option>
              <el-option label="联合投资(政府，社会)" value="4"></el-option>
            </el-select>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p>建设规模：</p>
            <el-input v-model="form.areas" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            <p style="width:100px;">平方</p>
          </div>
          <div class="item">
            <p>施工许可证：</p>
            <el-input v-model="form.permit" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p>合同价格：</p>
            <el-input v-model="form.price" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            <p style="width:100px;">万元</p>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p style="width:160px;">合同开工日期：</p>
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.startDate"
              @change="dataFun"
              style="felx:1;"
              value-format="yyyy-MM-dd"
              class="no-border"
            ></el-date-picker>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:160px;">合同竣工日期：</p>
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.endDate"
              @change="dataFun"
              style="felx:1;"
              value-format="yyyy-MM-dd"
              class="no-border"
            ></el-date-picker>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p>合同工期：</p>
            <!-- <el-input v-model="form.allDay" readonly style="flex:1;" class="no-border"></el-input> -->
            <p style="flex:1;" class="color1">{{form.allDay}}天</p>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p>银行网点：</p>
            <el-input v-model="form.bankAddress" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
          </div>
          <div class="item">
            <p>监管账户：</p>
            <el-input v-model="form.accountCapital" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            
          </div>
          <div class="item">
            <p>开户支行：</p>
            <el-input v-model="form.bankBranch" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            
          </div>
          <div class="item">
            <p>项目专户名称：</p>
            <el-input v-model="form.accountName" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
          </div>
        </div>
        <div class="pro-box1" style="margin-top: 10px;">
          <div class="item" style="width: 25%;">
            <p>保证金账号：</p>
            <el-input v-model="form.marginAccount" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
          </div>
          <div class="item" style="width: 25%;">
            <p>保证金账户名：</p>
            <el-input v-model="form.marginAccountName" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>
            
          </div>
          <div class="item" style="width: 25%;">
            <p>保证金开户行：</p>
            <el-input v-model="form.securityDepositOpeningBank" style="flex:1;" class="no-border" placeholder="请您编辑"></el-input>  
          </div>
        </div>
      </el-card>
      <el-card class="box-card pro-box2">
        <p style="margin:0 0 5px 0;text-align: left;">项目效果图：</p>
        <div class="box-img">
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :before-upload='upBefore'
            :on-success="handleSuccess1"
          >
            <img v-if="image1" :src="image1" class="avatar" style="margin: 0 30px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :before-upload='upBefore'
            :on-success="handleSuccess2"
          >
            <img v-if="image2" :src="image2" class="avatar" style="margin: 0 30px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :before-upload='upBefore'
            :on-success="handleSuccess3"
          >
            <img v-if="image3" :src="image3" class="avatar" style="margin: 0 30px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-card>


      <el-card>
        <p>四证一书：</p>
        <el-upload
          style="text-align: left;padding-left: 10px;margin-top: 10px;"
          :action="uploadUrl"
          :headers="uploadHead"
          :on-success="handleSuccess11"
          :data="{type:205}"
          :show-file-list="false"
          >
          <el-button size="small" type="primary" style="text-align: left;">点击上传</el-button>
          <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <div v-for="(file, index) in fileList1" :key="file.url" style="text-align: center;margin-right: 10px;">
              <img :src="file.url" style="width: 100px;height: 100px;">
              <p style="text-align: center;">{{ file.name }} <span @click.stop="deleteFile(index, 1)" style="color: red;" class="el-icon-delete-solid"></span></p>
            </div>
          </div>
        </el-upload>
      </el-card>

      <el-card>
        <p>项目计划进度表：</p>
         <el-upload
          style="text-align: left;padding-left: 10px;margin-top: 10px;"
          :action="uploadUrl"
          :headers="uploadHead"
          :on-success="handleSuccess22"
          :data="{type:205}"
          :show-file-list="false"
          >
          <el-button size="small" type="primary" style="text-align: left;">点击上传</el-button>
          <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <div v-for="file in fileList2" :key="file.name" style="text-align: center;margin-right: 10px;">
              <img :src="file.url" style="width: 100px;height: 100px;">
              <p style="text-align: center;">{{ file.name }} <span @click.stop="deleteFile(index, 2)" style="color: red;" class="el-icon-delete-solid"></span></p>
            </div>
          </div>
        </el-upload>
      </el-card>

      <el-card>
        <p>现场安全标志平面布置图：</p>
         <el-upload
          style="text-align: left;padding-left: 10px;margin-top: 10px;"
          :action="uploadUrl"
          :headers="uploadHead"
          :on-success="handleSuccess33"
          :data="{type:205}"
          :show-file-list="false"
          >
          <el-button size="small" type="primary" style="text-align: left;">点击上传</el-button>
          <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <div v-for="file in fileList3" :key="file.name" style="text-align: center;margin-right: 10px;">
              <img :src="file.url" style="width: 100px;height: 100px;">
              <p style="text-align: center;">{{ file.name }} <span @click.stop="deleteFile(index, 3)" style="color: red;" class="el-icon-delete-solid"></span></p>
            </div>
          </div>
        </el-upload>
      </el-card>
      <el-card>
        <p>项目总平面布置图：</p>
         <el-upload
          style="text-align: left;padding-left: 10px;margin-top: 10px;"
          :action="uploadUrl"
          :headers="uploadHead"
          :on-success="handleSuccess44"
          :data="{type:205}"
          :show-file-list="false"
          >
          <el-button size="small" type="primary" style="text-align: left;">点击上传</el-button>
          <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <div v-for="file in fileList4" :key="file.name" style="text-align: center;margin-right: 10px;">
              <img :src="file.url" style="width: 100px;height: 100px;">
              <p style="text-align: center;">{{ file.name }} <span @click.stop="deleteFile(index, 4)" style="color: red;" class="el-icon-delete-solid"></span></p>
            </div>
          </div>
        </el-upload>
      </el-card>

      <el-card>
        <p>现场临时用电平面布置图：</p>
         <el-upload
          style="text-align: left;padding-left: 10px;margin-top: 10px;"
          :action="uploadUrl"
          :headers="uploadHead"
          :on-success="handleSuccess55"
          :data="{type:205}"
          :show-file-list="false"
          >
          <el-button size="small" type="primary" style="text-align: left;">点击上传</el-button>
          <div style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <div v-for="file in fileList5" :key="file.name" style="text-align: center;margin-right: 10px;">
              <img :src="file.url" style="width: 100px;height: 100px;">
              <p style="text-align: center;">{{ file.name }} <span @click.stop="deleteFile(index, 5)" style="color: red;" class="el-icon-delete-solid"></span></p>
            </div>
          </div>
        </el-upload>
      </el-card>


      <el-card class="box-card" v-if="prot=='1'">
        <div class="pro-box3">
          <div class="item-con">
            <div class="item">
              <p style="width:160px;">建设单位：</p>
              <el-select v-model="form.entId" class="box-select" filterable placeholder="请选择">
                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <p style="width:100px;"></p>
            </div>
            <div class="item">
              <p style="width:160px;">联系人：</p>
              <!-- <el-input v-model="form.entManager" style="flex:1;"></el-input> -->
              <el-select
                v-model="form.entManager"
                class="box-select"
                filterable
                placeholder="请选择"
                style="flex:1;"
              >
                <el-option
                  v-for="item in persons"
                  :key="item.personId"
                  :label="item.name+'（'+item.idcard+'）'"
                  :value="item.personId"
                ></el-option>
              </el-select>
              <p style="width:100px;"></p>
            </div>
            <div class="item">
              <p style="width:160px;">联系人电话：</p>
              <el-input v-model="form.entTel" style="flex:1;"></el-input>
              <p style="width:100px;"></p>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box4">
          <div class="item-con">
            <div class="item">
              <p style="width:160px;">项目地址：</p>
              <el-cascader
                :props="{value:'id',label:'name'}"
                :options="areas"
                v-model="selectedOptions"
                change-on-select="true"
              ></el-cascader>
            </div>
            <div class="item">
              <p>详细位置：</p>
              <el-input v-model="form.address" style="flex:1;" class="no-border" placeholder="请您编辑"> </el-input>
            </div>
            <div
              v-if="form.id!=''&&form.id!='0'"
              class="item"
              style="margin-left:20px;color:#409EFF;"
            >
              <i class="el-icon-map-location" style="position: relative;top: -3px;font-size:2.5vh;cursor: pointer;" @click="goMapAddr"></i>
              <a style="cursor: pointer;" @click="goMapAddr">地图定位</a>
            </div>
          </div>
          <!-- <div class="item-con" style="height: 600px;width:100%;">
                    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
          </div>-->
        </div>
      </el-card>
    </el-form>
    <el-dialog :visible.sync="mapVisible" title="地图展示" @closed="mapClose" @open="mapOpen" width="90%" top="10vh" custom-class="map-dialog">
      <div class="item-con" style="height: 700px;width:100%;display: block;">
        <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import base from '../../untils/base'
import util from '../../untils/util.js'
export default {
  data() {
    return {
      imageUrl: '',
      form: {
        name:'',
        id: '',
        projectType: '1',
        projectStatus: '2',
        description: '',
        areas: '',
        permit: '',
        price: '',
        startDate: '',
        endDate: '',
        allDay: 0,
        photoPath: '',
        entId: '',
        entManager: '',
        entTel: '',
        constructionId: '',
        constructionManager: '',
        constructionTel: '',
        supervisionId: '',
        supervisionManager: '',
        supervisionTel: '',
        designId: '',
        designManager: '',
        designTel: '',
        surveyId: '',
        surveyManager: '',
        surveyTel: '',
        areaId: '',
        address: '',
        gpsPoint: '',
        detuoFlag: '', //是否上传到市平台
        loginId: '',
        bankAddress:'',
        accountCapital:'',
        bankBranch:'',
        accountName:'',
        yhType:'',  //投资方性质 - 只能用在讯飞那边  1  重点中心，3 社会项目
        marginAccount:'',//保证金账号
        marginAccountName:'',//保证金账户名 
        securityDepositOpeningBank:''//保证金开户行
      },
      entList:[],//参建单位
      selectedOptions: [],
      areas: [],
      projects: [],
      uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
      uploadHead: {
        //上传接口header参数
        accessToken: this.$store.state.token
      },
      image1: '',
      image2: '',
      image3: '',
      image: {
        img1: '',
        img2: '',
        img3: ''
      },
      //百度地图弹出框
      mapVisible:false,
      center: { lng: 117.283334, lat: 31.866339 },
      zoom: 13,
      map: {},
      geoc: {},
      persons: [], //项目人员
      types: [
        // { id: '1', name: '房建' },
        // { id: '2', name: '市政' },
        // { id: '3', name: '水利' },
        // { id: '4', name: '机电' }
      ],
      status: [
        { id: '1', name: '拟建' },
        { id: '2', name: '在建' },
        { id: '3', name: '竣工' },
        { id: '4', name: '停建' }
      ],
      prot: '',
      isUpload: [
        { label: '否', value: '0' },
        {
          label: '是',
          value: '1'
        }
      ], //是否上传到市平台
      loading:undefined,
      
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
    }
  },
  mounted() {
    this.getProjects()
    this.getArea()
    this.getProType()
    var params = this.$route.params
    this.prot = util.session.get('roleId')
    if (params.id == '0') {
      this.form.id = ''
    } else {
      this.form.id = params.id
      this.getPerson()
      this.getData()
      this.getJoinEnt()
    }
  },
  methods: {
    //项目类型
    getProType(){
      var that = this
      myHttp.getDictByType({
        type:'project_type'
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.dictList||[]
          that.types = list
          for(var i=0;i<list.length;i++){
            if(that.form.projectType==list[i].value){
              that.form.proTypeName = list[i].label
            }
          }
        }
      })
    },
    //获取项目人员
    getPerson() {
      var that = this
      myHttp
        .getProPerson({
          projectId: this.form.id
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo || []
              that.persons = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //获取区域
    getArea() {
      var that = this
      myHttp.getAreaList().then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.areaList
            var tree = util.common.listToTree('id', 'parentId', list)
            that.areas = tree
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {}
      )
    },
    //获取项目
    getProjects() {
      var that = this
      myHttp.getAllEnt().then(
        function(resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.entList || []
            that.projects = list
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {}
      )
    },
    //上传图片1
    handleSuccess1(res, file) {
      if (res.code == '200') {
        this.image1 = URL.createObjectURL(file.raw)
        this.image.img1 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
      this.loading.close();
    },
    //上传图片2
    handleSuccess2(res, file) {
      if (res.code == '200') {
        this.image2 = URL.createObjectURL(file.raw)
        this.image.img2 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
      this.loading.close();
    },
    //上传图片3
    handleSuccess3(res, file) {
      if (res.code == '200') {
        this.image3 = URL.createObjectURL(file.raw)
        this.image.img3 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
       this.loading.close();
    },

    getIcon(url) {
      console.log(url);
      let type = url.split('.')[url.split('.').length - 1]
      console.log(type);
      if(base.docType.includes(type)) {
        return require('../../assets/image/office/word.png')
      }else if(base.pdfType.includes(type)) {
        return require('../../assets/image/office/pdf.png')
      }else if(base.excelType.includes(type)) {
        return require('../../assets/image/office/excel.png')
      }else if(base.imgType.includes(type)) {
        return base.httpCtx + url + '?t=' + new Date().getTime()
      }
      else {
        return require('../../assets/image/office/undefined.png')
      }
    },

    handleSuccess11(res,file) {
      console.log(res);
      console.log(file);
      if(res.code === 200) {
        let obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.saveUrls
        obj.url = this.getIcon(res.data.saveUrls)
        this.fileList1.push(obj)
      }else {
        this.$message.error(res.msg)
      }
    },

    handleSuccess22(res,file) {
      if(res.code === 200) {
        let obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.saveUrls
        obj.url = this.getIcon(res.data.saveUrls)
        this.fileList2.push(obj)
      }else {
        this.$message.error(res.msg)
      }
    },

    handleSuccess33(res,file) {
     if(res.code === 200) {
        let obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.saveUrls
        obj.url = this.getIcon(res.data.saveUrls)
        this.fileList3.push(obj)
      }else {
        this.$message.error(res.msg)
      }
    },

    handleSuccess44(res,file) {
      if(res.code === 200) {
        let obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.saveUrls
        obj.url = this.getIcon(res.data.saveUrls)
        this.fileList4.push(obj)
      }else {
        this.$message.error(res.msg)
      }
    },

    handleSuccess55(res,file) {
      if(res.code === 200) {
        let obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.saveUrls
        obj.url = this.getIcon(res.data.saveUrls)
        this.fileList5.push(obj)
      }else {
        this.$message.error(res.msg)
      }
    },

    deleteFile(index, type) {
      if(type == 1) {
        this.fileList1.splice(index, 1)
      }else if(type == 2) {
        this.fileList2.splice(index, 1)
      }else if(type == 3) {
        this.fileList3.splice(index, 1)
      }else if(type == 4) {
        this.fileList4.splice(index, 1)
      }else if(type == 5) {
        this.fileList5.splice(index, 1)
      }
     
    },

    //获取数据
    getData() {
      var that = this
      myHttp
        .getProjectById({
          id: this.form.id
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var data = resp.data.data.project
            // that.form = data
            for(let key in that.form){
              that.form[key] = data[key]
            }
            console.log(that.form)
            var picList =
              data.photoPath && '' != data.photoPath
                ? data.photoPath.split(',')
                : []
            that.image1 = picList[0] ? base.httpCtx + picList[0] : that.image1
            that.image.img1 = picList[0] ? picList[0] : ''
            that.image2 = picList[1] ? base.httpCtx + picList[1] : that.image2
            that.image.img2 = picList[1] ? picList[1] : ''
            that.image3 = picList[2] ? base.httpCtx + picList[2] : that.image3
            that.image.img3 = picList[2] ? picList[2] : ''
            if (
              data.startDate &&
              data.startDate != '' &&
              data.endDate != '' &&
              data.endDate
            ) {
              that.form.allDay = util.myTime.getdayByDate(
                data.startDate,
                data.endDate
              )
            }
            if(that.types.length>0){
              for(var j=0;j<that.types.length;j++){
                if(data.projectType == that.types[j].value){
                  that.proTypeName = that.types[j].label
                }
              }
            }
            let fourCertificateBook = JSON.parse(data.fourCertificateBook)
            let scheduleDiagram = JSON.parse(data.scheduleDiagram)
            let siteSafetySigns = JSON.parse(data.siteSafetySigns)
            let generalPlan = JSON.parse(data.generalPlan)
            let temporaryElectrical = JSON.parse(data.temporaryElectrical)
            if(fourCertificateBook.length != 0) {
              console.log(fourCertificateBook);
               fourCertificateBook.forEach(item => {
                item.url = that.getIcon(item.fileUrl)
              })
            }

            if(scheduleDiagram.length != 0) {
              console.log(scheduleDiagram);
               scheduleDiagram.forEach(item => {
                item.url = that.getIcon(item.fileUrl)
              })
            }

            if(siteSafetySigns.length != 0) {
              siteSafetySigns.forEach(item => {
                item.url = that.getIcon(item.fileUrl)
              })
            }

            if(generalPlan.length != 0) {
              generalPlan.forEach(item => {
                item.url = that.getIcon(item.fileUrl)
              })
            }

            if(temporaryElectrical.length != 0) {
              temporaryElectrical.forEach(item => {
                item.url = that.getIcon(item.fileUrl)
              })
            }

            that.fileList1 = fourCertificateBook
            that.fileList2 = scheduleDiagram
            that.fileList3 = siteSafetySigns
            that.fileList4 = generalPlan
            that.fileList5 = temporaryElectrical

            that.setAreaFun(data && data.areaId)
            // if ("" != data.gpsPoint && undefined != data.gpsPoint) {
            //     var obj = data.gpsPoint.split(",");
            //     var point = { lng: obj[0], lat: obj[1] };
            //     that.center.lng = point.lng;
            //     that.center.lat = point.lat;
            //     that.setCenterMap(point);
            // }
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取区域
    setAreaFun(id) {
      if ('' == id || undefined == id) return
      var that = this
      myHttp
        .getAreaById({
          id: id
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var province = resp.data.data.area.provinceId
              var city = resp.data.data.area.cityId
              var area = resp.data.data.area.countyId
              if (resp.data.data.area.level == '3' && undefined == area) {
                area = resp.data.data.area.id
              }
              var arry = []
              arry.push(province)
              arry.push(city)
              arry.push(area)
              that.selectedOptions = arry
            }
          },
          function(error) {}
        )
    },
    //百度地图弹出框
    //解决鼠标滚动中心不再鼠标点上
    mapOpen: function () {
        this.top = this.getScrollTop()
        if (this.top) {
            this.setScrollTop(0)
        }
    },
    mapClose: function () {
        this.setScrollTop(this.top);
        this.top = 0;
    },
    getScrollTop: function () {
        let scrollTop = 0;
        if (document.documentElement && document.documentElement.scrollTop) {
            scrollTop = document.documentElement.scrollTop;
        } else if (document.body) {
            scrollTop = document.body.scrollTop;
        }
        return scrollTop;
    },
    setScrollTop: function (top) {
        if (!isNaN(top)) {
            if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                document.documentElement.scrollTop = top;
            } else if (document.body) {
                document.body.scrollTop = top;
            }
        }
    },
    //地图展示
    handler({ BMap, map }) {
      this.map = map
      this.geoc = new BMap.Geocoder()

      //根据内容展示中心点
      var data = this.form
      if ("" != data.gpsPoint && undefined != data.gpsPoint) {
          var obj = data.gpsPoint.split(",");
          var point = { lng: obj[0], lat: obj[1] };
          this.center.lng = point.lng;
          this.center.lat = point.lat;
          this.setCenterMap(point);
      }
    },
    //地图点击方法
    getClickInfo(e) {
      this.map.clearOverlays()
      var point = new BMap.Point(e.point.lng, e.point.lat)
      var marker = new BMap.Marker(point)
      this.map.addOverlay(marker)
      this.form.gpsPoint = e.point.lng + ',' + e.point.lat
      var that = this
      this.geoc.getLocation(e.point, function(rs) {
        var addComp = rs.addressComponents
        var address =
          addComp.province +
          addComp.city +
          addComp.district +
          addComp.street +
          addComp.streetNumber
        // that.form.address = address
        if(!that.form.address && that.form.address==''){
          that.form.address = address
        }
      })
    },
    //设置地图坐标和中点
    setCenterMap(obj) {
      var point = new BMap.Point(this.center.lng, this.center.lat)
      this.map.centerAndZoom(point, 12)
      var marker = new BMap.Marker(point)
      this.map.addOverlay(marker)
    },
    //保存当前项目
    saveProject() {
      console.log(this.selectedOptions)
      if (
        new Date(this.form.startDate).getTime() >
        new Date(this.form.endDate).getTime()
      ) {
        this.$message.error('计划开工日期不能大于竣工时间，请修改')
        return
      }
      if (this.form.name == '') {
        this.$message.error('请输入项目名称')
        return
      }
      var that = this
      this.form.userId = this.$store.state.user.id
      this.form.photoPath =
        this.image.img1 + ',' + this.image.img2 + ',' + this.image.img3
      this.form.areaId = this.selectedOptions[this.selectedOptions.length - 1]
      
      for(let i=0;i<this.fileList1.length;i++){
        delete this.fileList1[i].url
      }
      for(let i=0;i<this.fileList2.length;i++){
        delete this.fileList2[i].url
      }
      for(let i=0;i<this.fileList3.length;i++){
        delete this.fileList3[i].url
      }
      for(let i=0;i<this.fileList4.length;i++){
        delete this.fileList4[i].url
      }
      for(let i=0;i<this.fileList5.length;i++){
        delete this.fileList5[i].url
      }
      this.form.fourCertificateBook = JSON.stringify(this.fileList1)
      this.form.scheduleDiagram = JSON.stringify(this.fileList2)
      this.form.siteSafetySigns = JSON.stringify(this.fileList3)
      this.form.generalPlan = JSON.stringify(this.fileList4)
      this.form.temporaryElectrical = JSON.stringify(this.fileList5)

      if (this.form.id == '' || this.form.id == '0') {
        myHttp.createProject(this.form).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.$router.go(-1)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      } else {
        delete this.form.updateDate
        delete this.form.createDate
        delete this.form.teams
        myHttp.updateProject(this.form).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('修改成功')
            that.$router.go(-1)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
    //跳转
    goMapAddr() {
      // this.$router.push({ name: 'proPoint', params: { id: this.form.id } })
      this.mapVisible = true
    },
    //监听时间
    dataFun(val) {
      if (
        this.form.startDate &&
        this.form.startDate != '' &&
        this.form.endDate != '' &&
        this.form.endDate
      ) {
        this.form.allDay = util.myTime.getdayByDate(
          this.form.startDate,
          this.form.endDate
        )
      }
    },
    //s上传前
    upBefore(file){
      this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      });
    },
     //获取参建单位
     getJoinEnt(){
            var that = this
            myHttp.getProjectEntByProjectId({
                projectId:this.$store.state.groupId
            }).then(function(resp){
                if (resp.data.code == '200'){
                    var list = resp.data.data.projectEnt || []
                    that.entList = list
                }else{

                }
            })
        },
  }
}
</script>
<style scoped>
.content ::v-deep .el-upload {
  text-align: left;
}
.content {
  height: 100%;
  padding: 0 10px;
  overflow: auto;
}
.title{
    width: 100%;
    height: 3vh;
    position: relative;
    display: flex;
    /* align-content: center;
    align-items: center; */
    padding-left: 1vw;
}
.title .el-breadcrumb{
  display: flex;
  align-content: center;
  align-items: center;
}
.proName-box {
  background: #fff;
  padding: 20px 60px;
}
.pro-box1,
.box-img,
.pro-box3,
.pro-box4 {
  display: flex;
  width: 100%;
}
.pro-box3,
.pro-box4 {
  flex-wrap: wrap;
}
.pro-box3 .item-con,
.pro-box4 .item-con {
  width: 100%;
  display: flex;
  margin-top: 15px;
}
.pro-box1 .item,
.item-con .item {
  width: 33%;
  display: flex;
  align-items: center;
}
.pro-box4 .item-con .item {
  width: 50%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #ddd;
  margin: 0 30px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.box-card {
  margin-bottom: 20px;
}
p {
  text-align: left;
  margin: 0;
  padding-left: 10px;
}
.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.box-select .el-input {
  width: 100%;
}

</style>
<style>
.projectAdd .el-select,
.projectAdd .el-select > .el-input,
.projectAdd .el-select .el-input__inner {
  width: 240px;
}
/* .no-border .el-textarea__inner,
.no-border .el-input__inner{
  border: 0;
} */
.projectAdd .el-textarea__inner,
.projectAdd .el-input__inner{
  color: #000;
  
}
.ul_box{
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  height: 100px;
}
.ul_box>li>div{
  text-align:left;
  margin: 20px 0;
}

</style>